import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { MobileLayout } from './components/mobileLayout'
import { BottomNavigation } from './components/bottomNavigation'
import InWinNotification from 'shared/components/inwinNotification'

const EventsOverviewComponent = ({
  title = 'Tournaments',
  columns,
  loadEvents,
  loadUpcomingTournaments,
  loadAllTournaments,
  onSearch,
  appConfig,
}) => (
  <>
    <InWinNotification />
    <MobileLayout
      title={title}
      columns={columns}
      loadEvents={loadEvents}
      loadUpcomingTournaments={loadUpcomingTournaments}
      loadAllTournaments={loadAllTournaments}
      onSearch={onSearch}
      appConfig={appConfig}
    />
    <BottomNavigation />
  </>
)

EventsOverviewComponent.propTypes = {
  title: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadEvents: PropTypes.func.isRequired,
  loadUpcomingTournaments: PropTypes.func.isRequired,
  loadAllTournaments: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  appConfig: PropTypes.shape(),
}

export default observer(EventsOverviewComponent)
